<template>
    <v-container class="max-container">
        <v-row class="flex-col-start" v-if="visibleNewspaper.length > 0 ">
            <span v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl " class="vcontainer_vrow__titlescreen"> Jornal de Ofertas </span>
            <div class="flex-row-start" :class="visibleNewspaper.length < 3 ? '' : 'justify-space-between' " style="width: 100%">
                <v-col v-for="(newspaper, index) in visibleNewspaper" :key="index" cols="12" sm="12" md="3" lg="3" xl="3">
                    <div class="flex-row-start" style="padding-bottom: 6px">
                        <v-icon color="var(--cor--preta)">mdi-calendar-blank</v-icon>
                        <span>{{newspaper.dateSend}} - {{newspaper.hourSend}}</span>
                    </div>
                    <v-img contain class="newspaperimg" :src="newspaper.image" @click="openShowNewspaper(newspaper.image)"/>
                </v-col>
            </div>            
                      
            <v-col>
                <v-pagination
                    v-model="page"
                    :length="totalPage"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                ></v-pagination>
            </v-col>
        </v-row> 
        <!--Empty-->
        <v-row v-else class="flex-col-center">
            <v-img class="div__emptyimg" src="@/assets/empty-views/empty_jornal.svg"/>
        </v-row>
        <showNewspaper :dialog="newspaperDialog" :newspaper="newspaperImg" @closedShowNewspaper="newspaperDialog = $event"/>
    </v-container>
</template>

<script>
//Component
import showNewspaper from "@/app/modals/show-newspaper-modal/show-newspaper-modal"

export default {
    name: 'offerNewspaper',
    props:{
        newspaperArr: {
            type: Array
        }
    },
    components: { showNewspaper },
    data: () => ({  
        page: 1,
        visibleNewspaper: [],
        totalPage: null,
        newspaperDialog: false,
        newspaperImg: '',
    }),
    watch: {
        newspaperArr: {
            deep: true,
            immediate: true,
            handler() {
                if(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
                    this.listItems(this.newspaperArr, this.page, 1)
                } else {
                    this.listItems(this.newspaperArr, this.page, 3)
                }
            }
        },
        page: {
            deep: true,
            handler() {
                if(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
                    this.listItems(this.newspaperArr, this.page, 1)
                } else {                    
                    this.listItems(this.newspaperArr, this.page, 3)
                }
            }
        },
        visibleNewspaper: {
            deep: true,
            handler() {
                this.setDateAndHourOfNewspaperList(this.visibleNewspaper)
            }
        }
    },
    created() {
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
        compareWidth() {
            if( window.innerWidth <= 960 ) {
                this.listItems(this.newspaperArr, this.page, 1)
            } else {
                this.listItems(this.newspaperArr, this.page, 3)
            }
        },
        listItems(items, pageActual, limitItems) {
            let result = [];
            this.totalPage = Math.ceil( items.length / limitItems );
            let count = ( pageActual * limitItems ) - limitItems;
            let delimiter = count + limitItems;

            if(pageActual <= this.totalPage) {
                //create loop
                for(let i=count; i<delimiter; i++) {
                    if(items[i] != null) {
                        //push in result
                        result.push(items[i]);
                    }
                    //increment count
                    count++;
                }
            }
            this.visibleNewspaper = result
        },
        getHourByTimeStamp( data ){
            var moment = require('moment')
            var formatted = moment(data).format("HH:mm")
            return formatted
        },
        getDateByTimeStamp( data ){
            var moment = require('moment')
            var formatted =  moment(data).format("DD/MM/YYYY")
            return formatted;
        },
        setDateAndHourOfNewspaperList(listNewspaper) {
            if( listNewspaper.length > 0 ) {
                listNewspaper.forEach(element => {
                        var dateSend = this.getDateByTimeStamp( element.dateAdded )
                        var hourSend = this.getHourByTimeStamp( element.dateAdded )
                        listNewspaper[listNewspaper.indexOf(element)].dateSend = dateSend
                        listNewspaper[listNewspaper.indexOf(element)].hourSend = hourSend
                    }
                )
            }
        },
        openShowNewspaper(imgNewspaper) {
          var isDesktop = this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
          
          if(isDesktop) {
            this.newspaperImg = imgNewspaper
            this.newspaperDialog = true
          }          
        }
    }

}
</script>

<style scoped>
.newspaperimg {
    border-radius: 12px;
    min-height: 450px;
    max-height: 450px;
    cursor: pointer;
    /* min-width: 350px; */
    /* max-width: 350px; */
}
.vcontainer_vrow__titlescreen {
    padding-left: 12px;
    font-weight: 800;
    font-size: 24px;
}
.div__emptyimg {
    width: 220px;
}
</style>